import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons/faTrashCan";
import ValidToast from "../../toasts/ValidToast";
import UnvalidToast from "../../toasts/UnvalidToast";
import { deleteTrocProposal } from "../../../services/callAPI/trocsPropositions";

interface IBtnIconeTrashProps {
  travTrocId: number;
  resTrocId: number;
  setTrigUseEffect: React.Dispatch<React.SetStateAction<boolean>>;
}

function BtnIconeProposalTrash(props: IBtnIconeTrashProps) {
  //destructuring
  const { resTrocId, travTrocId, setTrigUseEffect } = props;

  const [isShowValidToast, setIsShowValidToast] = useState<boolean>(false);

  const [isShowUnvalidToast, setIsShowUnvalidToast] = useState<boolean>(false);

  const [errorMsg, seterrorMsg] = useState<string | undefined>(undefined);

  async function handleDeleteTrocProposal(trocRId: number, trocTId: number) {
    try {
      //call API
      const status = await deleteTrocProposal(trocTId, trocRId);

      if (status === 204) {
        //show Validtoast
        setIsShowValidToast(true);

        const timer = setTimeout(() => {
          setTrigUseEffect(prev => !prev);
        }, 4000);

        return () => clearTimeout(timer);
      }
      else {
        throw new Error(`Erreur lors de l'appel API, statut: ${status}`);
      }

    } catch (error) {
      if (error instanceof Error) {
        seterrorMsg(error.message);//add error msg

        //show UnvalidToast
        setIsShowUnvalidToast(true);
      }
      else {
        //show UnvalidToast
        setIsShowUnvalidToast(true);

        const timer = setTimeout(() => {
          setTrigUseEffect(prev => !prev);
        }, 4000);

        //clean timer
        return () => clearTimeout(timer);
      }
    }
  }

  return (
    <>
      {isShowValidToast && <ValidToast onClose={() => setIsShowValidToast(false)} />}
      {isShowUnvalidToast && <UnvalidToast message={errorMsg} onClose={() => setIsShowUnvalidToast(false)} />}

      <button className="w-1/3 max-w-52 border-none focus:outline-none focus:ring-transparent ml-auto mr-auto" onClick={() => handleDeleteTrocProposal(resTrocId, travTrocId)}>
        <i className="bg-redCustom rounded-full py-1 px-4 text-white">
          <FontAwesomeIcon icon={faTrashCan} />
        </i>
      </button>
    </>
  )
}
export default BtnIconeProposalTrash;